<template>
  <div>
    channel: {{ $_.get(channel, 'name') }}
  </div>
</template>

<script>
  export default {
    name: 'ChannelDetail',
    routeConfig: {
      name: "channelDetail", path: "/channels/:id"
    },
    metaInfo () {
      return {
        // title: this.channelName
      }
    },
    data () {
      return {
        channel: null
      }
    },
    created () {
      this.$store.find('channels', this.$route.params.id)
        .then((channel) => {
          this.channel = channel
        })
        .catch((err) => {
          // TODO: What to put here?
          // this.$router.push({name: "assignments"})
        })
    },
    // computed: {
    //   channelName () {
    //     return _.get(this.channel, "name") || ""
    //   }
    // }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/routes/Channels/detail.vue